import { ContactInfoGrouped } from 'feature/clientTabs/general/contactInfo/useContactInfo';
import { ContactInfoFieldKeyType } from 'typings/form';
import { generateUniqueId } from 'utils/helpers';

// groups contact info by type
export const groupContactInfoByType = (contactPersonInfoFields: { type: ContactInfoFieldKeyType; value: string }[]) => {
  return contactPersonInfoFields.reduce((acc, field) => {
    if (!acc[field.type]) {
      acc[field.type] = [];
    }
    acc[field.type].push(field.value);
    return acc;
  }, {} as ContactInfoGrouped);
};

// generates a list of contact info
export const generateContactInfoList = (contactInfoMapping: Record<ContactInfoFieldKeyType, string[]> | undefined) => {
  return (
    Object.entries(contactInfoMapping || {}).flatMap(([key, values]) => {
      const typedKey = key as ContactInfoFieldKeyType;
      return (values as string[]).map((value) => ({
        type: typedKey,
        value,
        id: generateUniqueId(),
      }));
    }) || []
  );
};
// filters contact info for show all or less
export const filterContactInfo = (
  data: ContactInfoGrouped,
  showAll: boolean,
  maxVisibleItems: number = 6
): ContactInfoGrouped => {
  if (!data) {
    return {} as ContactInfoGrouped;
  }
  const flattened: {
    type: ContactInfoFieldKeyType;
    value: string;
  }[] = Object.entries(data).flatMap(([type, values]) => {
    return (values as string[]).map((value) => ({ type: type as ContactInfoFieldKeyType, value }));
  });
  const sliced = showAll ? flattened : flattened.slice(0, maxVisibleItems);
  return sliced.reduce<ContactInfoGrouped>((grouped, { type, value }) => {
    if (!grouped[type]) {
      grouped[type] = [];
    }
    grouped[type].push(value);
    return grouped;
  }, {} as ContactInfoGrouped);
};

// should show see more
export const shouldShowSeeMore = (value: Record<string, string[]>, maxVisibleItems: number = 6) =>
  Object.values(value || {}).reduce((sum, values) => sum + values.length, 0) > maxVisibleItems;
